export default __webpack_public_path__ + "static/media/icon_calendar.8f52a544.svg";